<template>
  <PageView :loading="loading" :logo="logo" header-class="bg-light" class="bg-light d-flex flex-column flex-grow-1" container-class="d-flex flex-column flex-grow-1">
    <ScrollDownIndicatorComponent ref="scrollDownIndicator" />
    <div class="card d-flex flex-column flex-grow-1" v-if="participation">
      <div class="card-body pt-0 px-0 d-flex flex-column flex-grow-1">
        <TravelBannerComponent :participation="participation" />

        <div class="row justify-content-center m-2 m-md-3 mt-0 d-flex flex-column flex-grow-1">
          <h2 class="card-title text-center my-4 d-flex justify-content-between flex-column flex-md-row">
            <div class="col text-start">
              <router-link custom :to="{ name: 'home' }" v-slot="{ navigate }">
                <button
                  class="btn btn-outline-primary text-nowrap d-none d-md-block"
                  @click="navigate"
                >
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
            <div>Informations pratiques</div>
            <div class="col"></div>
            <div class="col text-start d-block d-md-none mt-2">
              <router-link custom :to="{ name: 'home' }" v-slot="{ navigate }">
                <button class="btn btn-outline-primary text-nowrap" @click="navigate">
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
          </h2>

          <div v-if="!travelPages || travelPages.length === 0" class="text-center">
            <p class="text-muted fs-5">Aucune information pratique disponible pour ce séjour.</p>
            <router-link :to="{ name: 'home' }" class="btn btn-primary mt-2">
              <i class="fa-solid fa-angle-left me-2"></i> Retour à l'accueil
            </router-link>
          </div>
          <div v-else class="col p-0 p-md-2">
            <div class="card mb-3" v-for="(page, idx) in travelPages" :key="idx">
              <h4 class="card-header text-uppercase">{{ page.title }}</h4>
              <div v-html="normalizeRichTextContent(page.content)" class="card-body ql-editor pt-2"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </PageView>
</template>

<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/stores/notificationStore'
import { getPictureUrl, normalizeRichTextContent } from '@/compositions/helper'
import travelApi from '@/api/travelApi'
import PageView from '@/views/PageView.vue';

const router = useRouter()
const notificationsStore = useNotificationsStore()

const props = defineProps<{ id?: number; slug?: string }>()

const loading = ref(true)
const participation = ref<UserParticipation | null>(null)
const travelPages = ref<UserTravelPage[]>([])

// Computed
const logo = computed(() => {
  if (participation.value?.travel.logo?.key) {
    return getPictureUrl(participation.value.travel.logo.key)
  }
  return undefined
})

onMounted(() => {
  const loadParticipation = props.id
    ? travelApi.getParticipation(Number(props.id))
    : props.slug
      ? travelApi.getParticipationBySlug(props.slug)
      : null

  if (!loadParticipation) {
    router.push({ name: 'home' })
    return
  }

  loadParticipation
    .then((response) => {
      participation.value = response.data
      travelApi.getTravelPages(participation.value.travel.id!).then((response) => {
        travelPages.value = response.data;
      }).catch((error: Error) => {
        notificationsStore.notifyError('Erreur lors du chargement de la page',error.message)
        router.push({ name: 'home' })
      });
    })
    .catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors du chargement de la page',error.message)
      router.push({ name: 'home' })
    })
    .finally(() => {
      loading.value = false
    })
})
</script>
